import { createBrowserHistory } from "history";
import { persistStore } from "redux-persist";

import { configureStore } from "./configureStore";

// if (process.env.NODE_ENV !== "test") {
//   /* eslint-disable */
//   h1 = createBrowserHistory();
//   store = configureStore(initialState, history).store;
//   persistor = persistStore(store);
//   /* eslint-enable */
// }

const initialState = {};
const history = process.env.NODE_ENV !== "test" ? createBrowserHistory() : null;
const store = process.env.NODE_ENV !== "test" ? configureStore(initialState, history).store : null;
const persistor = process.env.NODE_ENV !== "test" ? persistStore(store) : null;

export { store, history, persistor, initialState };
